import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING } from '../constants'
import { receiveSuccessAlert } from './alerts'
import { requestAssessmentSummary } from './assessment'
import { handleRequestError } from './request'

export const REQUEST_EMPLOYMENTS = 'REQUEST_EMPLOYMENTS'
export const RECEIVE_EMPLOYMENTS = 'RECEIVE_EMPLOYMENTS'
export const CREATE_EMPLOYMENT = 'CREATE_EMPLOYMENT'
export const SAVE_EMPLOYMENT = 'SAVE_EMPLOYMENT'
export const REMOVE_AND_DELETE_EMPLOYMENT = 'REMOVE_AND_DELETE_EMPLOYMENT'
export const REMOVE_EMPLOYMENT = 'REMOVE_EMPLOYMENT'
export const DELETE_EMPLOYMENT = 'DELETE_EMPLOYMENT'

export const EMPLOYMENT_SAVE = 'EMPLOYMENT_SAVE'
export const EMPLOYMENT_SAVING = 'EMPLOYMENT_SAVING'
export const EMPLOYMENT_SAVE_SUCCESS = 'EMPLOYMENT_SAVE_SUCCESS'
export const EMPLOYMENT_SAVE_ERROR = 'EMPLOYMENT_SAVE_ERROR'

export const requestEmployments = (selfAssessmentId) => (dispatch) => {
    dispatch({ type: REQUEST_EMPLOYMENTS, data: { selfAssessmentId } })

    axios
        .get(`/employments?selfAssessmentId=${selfAssessmentId}`)
        .then((response) => {
            const responseData = _get(response, ['data'], [])

            dispatch(
                receiveEmployments({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            dispatch(receiveEmployments({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveEmployments = (data) => ({ type: RECEIVE_EMPLOYMENTS, data })

export const createEmployment = (data) => (dispatch) => {
    dispatch({ type: CREATE_EMPLOYMENT, data })

    return axios
        .post('/employment', data)
        .then((response) => {
            const responseData = _get(response, ['data'], {})

            dispatch(
                receiveEmployments({
                    items: [responseData],
                })
            )

            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

// export const updateAndSaveEmployment = (data) => {
//     return (dispatch) => {
//         dispatch({ type: UPDATE_AND_SAVE_EMPLOYMENT, data })

//         dispatch(receiveEmployments({items: [data]}))

//         return dispatch(saveEmployment(data))
//     }
// }

export const saveEmployment = (data) => (dispatch) => {
    dispatch({ type: SAVE_EMPLOYMENT, data })

    const { id } = data

    return axios
        .put(`/employment/${id}`, data)
        .then((response) => {
            const responseData = _get(response, ['data'], {})

            dispatch(
                receiveEmployments({
                    items: [responseData],
                })
            )
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const removeAndDeleteEmployment =
    (id, options = {}) =>
    (dispatch) => {
        dispatch({ type: REMOVE_AND_DELETE_EMPLOYMENT, data: { id } })

        dispatch(removeEmployment(id))
        return dispatch(deleteEmployment(id, options))
    }

export const removeEmployment = (id) => ({ type: REMOVE_EMPLOYMENT, data: { id } })

export const deleteEmployment =
    (id, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_EMPLOYMENT, data: { id } })

        return axios
            .delete(`/employment/${id}`)
            .then(() => {
                dispatch(removeEmployment(id))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert(`Employment deleted`))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
            })
    }

export const saveEmployments = (data) => (dispatch, getState) => {
    const { assessment } = getState()

    dispatch(employmentSaving, data)

    return axios
        .post('/employments/', data.items)
        .then((response) => {
            const items = response.data

            dispatch(employmentSaveSuccess({ items }))
            dispatch(requestAssessmentSummary(assessment.id))
        })
        .catch((error) => {
            const existingEmployment = { ...data }
            dispatch(employmentSaveError(existingEmployment, _get(error, ['response', 'data'])))
        })
}

export const updateAndSaveEmployments = (data) => (dispatch) => {
    dispatch(receiveEmployments(data))
    dispatch(saveEmployments(data)).catch(() => {})
}

export const employmentSaving = (data) => ({
    type: EMPLOYMENT_SAVING,
    data,
})

export const employmentSaveSuccess = (data) => ({
    type: EMPLOYMENT_SAVE_SUCCESS,
    data,
})

export const employmentSaveError = (data, errorResponse) => ({
    type: EMPLOYMENT_SAVE_ERROR,
    data,
    errorResponse,
})
